import KsDmvService from '../../../service/KsDmvService';
import NcDmvService from '../../../service/NcDmvService';
import { serviceOfferingIds, } from '../../../modules/Constants';
import Numbers from '../../../modules/Numbers';

const getPaidOffering = ({ serviceOfferingId, transactionId, }) => {
  switch (serviceOfferingId) {
    case serviceOfferingIds.KS_DMV:
      return KsDmvService.getKsDmvRenewalsBySearchCriteria({ transactionId, }).then((res) => {
        const { renewals, } = res.data;
        return renewals.map(value => ({
          id: value.id,
          amount: Numbers.addAll(
            [ value.propertyFee, value.registrationFee, value.specialFee, ].map(Numbers.toNumber)
          ),
          serviceOfferingId: serviceOfferingIds.KS_DMV,
        }));
      });
    case serviceOfferingIds.NC_DMV:
      return NcDmvService.getNcDmvRenewalsBySearchCriteria({ transactionId, }).then((res) => {
        const { renewals, } = res.data;
        return renewals.map(value => ({
          serviceOfferingId: serviceOfferingIds.NC_DMV,
          id: value.id,
        }));
      });
    default:
      return Promise.resolve([]);
  }
};

export default {
  getPaidOffering,
};
